export const SET_ERROR_MESSAGE = 'error/SET_ERROR_MESSAGE'
